<template>
    <div data-html2canvas-ignore>
        <a class="feedback-button" role="button" @click.prevent="openModal = true; resetForm()"></a>
        <portal to="modals" v-if="openModal == true">
            <b-modal
                :hideFooter="true"
                v-if="openModal == true"
                v-model="openModal"
                :title="uLang('app.feedback')"
                size="lg"
                data-html2canvas-ignore
            >
                <rea-loader :loading="loading"></rea-loader>
                <form @submit.prevent="submitFeedback" ref="feedbackForm">
                    <div class="form-group" v-bind:class="{ 'has-danger' : errors.includes('name') }">
                        <label class="col-form-label" for="name">{{ uLang('app.name') }}: *</label>
                        <input
                            type="text"
                            class="form-control"
                            name="name"
                            v-model="name"
                            required="true"
                        >
                        <span class="help-block form-control-feedback" v-if="errors.includes('name')" v-text="errors.name.find()"></span>
                    </div>
                    <div class="form-group" v-bind:class="{ 'has-danger' : errors.includes('notes') }">
                        <label class="col-form-label" for="notes">{{ uLang('app.notes') }}: *</label>
                        <textarea class="form-control" name="notes" v-model="notes" rows="3" required="true"></textarea>
                        <span class="help-block form-control-feedback" v-if="errors.includes('notes')" v-text="errors.notes.find()"></span>
                    </div>
                    <button class="btn btn-brand" type="submit">{{ uLang('app.send_feedback') }}</button>
                </form>
            </b-modal>
        </portal>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas';
    import { mapGetters } from 'vuex'
    import { SuccessAlert, ErrorAlert } from "~/Swals"
    import { ReaLoader } from '~/components/helpers'

    export default {
        name: "FeedbackForm",

        components: {
            ReaLoader,
        },

        data() {
            return {
                notes: null,
                screenshot: null,
                name: null,
                openModal: false,
                loading: false,
                errors: [],
            }
        },

        mounted() {
            this.name = this.user.full_name
        },

        computed: {
            ...mapGetters({
                'user': 'authUser'
            })
        },

        methods: {
            createScreenshot() {
                return new Promise((resolve, reject) => {
                    html2canvas(document.body, { logging: false }).then((canvas) => {
                        this.screenshot = canvas.toDataURL()
                        resolve();
                    }).catch((err) => reject(err));
                })
            },
            submitFeedback() {
                this.loading = true
                let runFinally = true
                this.createScreenshot().then(() => {
                    window.axios.post(route('feedback.create'), {
                        name: this.name,
                        page: window.location.href.substr(0, 191),
                        notes: this.notes,
                        screenshot: this.screenshot,
                    }).then(({ data }) => {
                        new SuccessAlert({ text: this.uLang('app.feedback_sent_success')}).show();
                    }).catch((error) => {
                        if(error.response.status == 422) {
                            this.errors = response.data.errors
                            runFinally = false
                            return;
                        }
                        new ErrorAlert({ text: this.uLang('app.feedback_sent_failure')}).show();
                    }).finally(() => {
                        if (runFinally) {
                            this.openModal = false
                            this.loading = false
                        }
                    })
                })
            },
            resetForm() {
                this.notes = null
            },
        }
    }
</script>

<style>
    .feedback-button {
        position: fixed;
        height: 197px;
        width: 35px;
        right: 0;
        top: 190px;
        background: url('~/img/feedback-right.png') no-repeat;
        z-index: 9002;
    }
</style>